export default "__VITE_ASSET__$x1CcR0z__"